import { Locale } from '@embedpdf/react-pdf-viewer';

export const itIT: Locale = {
	code: 'it',
	name: 'Italiano',
	translations: {
		search: {
			placeholder: 'Cerca',
			caseSensitive: 'Maiuscole/minuscole',
			wholeWord: 'Parola intera',
			resultsFound: '{count} risultati trovati',
			page: 'Pagina {page}',
		},
		zoom: {
			in: 'Aumenta zoom',
			out: 'Riduci zoom',
			fitWidth: 'Adatta alla larghezza',
			fitPage: 'Adatta alla pagina',
			marquee: 'Zoom su area',
			menu: 'Menu zoom',
			level: 'Livello di zoom ({level}%)',
			dragTip: "Trascina per selezionare l'area da ingrandire",
		},
		pan: {
			toggle: 'Attiva/disattiva modalità panoramica',
		},
		pointer: {
			toggle: 'Attiva/disattiva modalità puntatore',
		},
		capture: {
			screenshot: 'Cattura schermata',
			dragTip: "Trascina per selezionare l'area da catturare",
			title: 'Anteprima cattura',
			download: 'Scarica',
			cancel: 'Annulla',
		},
		document: {
			menu: 'Menu documento',
			open: 'Apri',
			close: 'Chiudi',
			print: 'Stampa',
			protect: 'Sicurezza',
			export: 'Esporta',
			fullscreen: 'Schermo intero',
			loading: 'Caricamento documento...',
		},
		emptyState: {
			title: 'Nessun documento aperto',
			description: 'Apri un documento PDF per iniziare.',
			descriptionMulti: 'Puoi visualizzare più documenti utilizzando le schede.',
			openButton: 'Apri documento',
			supportedFormats: 'Formato supportato: PDF',
		},
		passwordPrompt: {
			title: 'Password richiesta',
			required: 'Questo documento è protetto da password. Inserisci la password per aprirlo.',
			incorrect: 'La password inserita non è corretta. Riprova.',
			incorrectWarning: 'Password errata. Controlla e riprova.',
			label: 'Password',
			placeholder: 'Inserisci la password del documento',
			open: 'Apri',
			opening: 'Apertura...',
			cancel: 'Annulla',
			close: 'Chiudi',
		},
		documentError: {
			title: 'Errore durante il caricamento del documento',
			unknown: 'Si è verificato un errore sconosciuto',
			errorCode: 'Codice errore: {code}',
			close: 'Chiudi documento',
		},
		panel: {
			sidebar: 'Barra laterale',
			search: 'Cerca',
			comment: 'Commento',
			thumbnails: 'Miniature',
			outline: 'Indice',
			annotationStyle: 'Stile annotazione',
			redaction: 'Barra laterale redazioni',
		},
		menu: {
			viewControls: 'Controlli di visualizzazione',
			zoomControls: 'Controlli zoom',
			moreOptions: 'Altre opzioni',
		},
		outline: {
			title: 'Indice',
			loading: 'Caricamento indice...',
			noOutline: 'Nessun indice disponibile',
			noBookmarks: 'Questo documento non contiene segnalibri',
		},
		page: {
			settings: 'Impostazioni pagina',
			single: 'Pagina singola',
			twoOdd: 'Due pagine (dispari)',
			twoEven: 'Due pagine (pari)',
			vertical: 'Verticale',
			horizontal: 'Orizzontale',
			spreadMode: 'Modalità doppia pagina',
			scrollLayout: 'Disposizione scorrimento',
			rotation: 'Rotazione pagina',
			next: 'Pagina successiva',
			previous: 'Pagina precedente',
		},
		rotate: {
			clockwise: 'Ruota in senso orario',
			counterClockwise: 'Ruota in senso antiorario',
		},
		selection: {
			copy: 'Copia selezione',
		},
		mode: {
			view: 'Visualizza',
			annotate: 'Annota',
			shapes: 'Forme',
			form: 'Modulo',
			redact: 'Redigi',
			insert: 'Inserisci',
		},
		form: {
			textfield: 'Campo di testo',
			checkbox: 'Casella di controllo',
			radio: 'Pulsante di opzione',
			select: 'Menu a tendina',
			listbox: 'Casella di riepilogo',
		},
		annotation: {
			text: 'Testo',
			highlight: 'Evidenzia',
			strikeout: 'Barrato',
			underline: 'Sottolineato',
			squiggly: 'Ondulato',
			rectangle: 'Rettangolo',
			circle: 'Cerchio',
			line: 'Linea',
			arrow: 'Freccia',
			polygon: 'Poligono',
			polyline: 'Polilinea',
			ink: 'Penna',
			inkHighlighter: 'Evidenziatore a mano libera',
			stamp: 'Timbro',
			caret: 'Segno di inserimento',
			insertText: 'Inserisci testo',
			replaceText: 'Sostituisci testo',
			freeText: 'Testo libero',
			square: 'Quadrato',
			style: 'Stile annotazione',
			styles: 'Stili {type}',
			defaults: 'Impostazioni predefinite {type}',
			color: 'Colore',
			opacity: 'Opacità',
			blendMode: 'Metodo di fusione',
			strokeWidth: 'Spessore tratto',
			strokeColor: 'Colore tratto',
			borderStyle: 'Stile bordo',
			fillColor: 'Colore riempimento',
			fontSize: 'Dimensione carattere',
			fontFamily: 'Carattere',
			textAlign: 'Allineamento testo',
			verticalAlign: 'Allineamento verticale',
			lineEnding: 'Estremità linea',
			lineStart: 'Inizio linea',
			lineEnd: 'Fine linea',
			font: 'Carattere',
			fontColor: 'Colore carattere',
			backgroundColor: 'Colore sfondo',
			noStyles: 'Non ci sono stili per questa annotazione.',
			noStylesStamp: 'Non ci sono stili per i timbri.',
			selectAnnotation: "Seleziona un'annotazione per vedere gli stili",
			deleteSelected: 'Elimina annotazione selezionata',
			deleteAllSelected: 'Elimina selezionate',
			multiSelect: '{count} annotazioni selezionate',
			group: 'Raggruppa',
			ungroup: 'Separa',
			moreTools: 'Altri strumenti',
			addLink: 'Aggiungi link',
			removeLink: 'Rimuovi link',
			gotoLink: 'Vai al link',
			comment: 'Commento',
			callout: 'Didascalia',
			redact: 'Redigi',
			overlayText: 'Testo sovrapposto',
			overlayTextPlaceholder: 'es. RISERVATO',
			rotation: 'Rotazione',
		},
		insert: {
			image: 'Immagine',
			rubberStamp: 'Timbro',
		},
		redaction: {
			redact: 'Redigi',
			area: 'Redigi area',
			text: 'Redigi testo',
			apply: 'Applica redazione',
			applyAll: 'Applica tutto',
			clearAll: 'Cancella tutto',
			deleteSelected: 'Elimina redazione selezionata',
			commitSelected: 'Applica redazione selezionata',
			emptyState: 'Nessuna redazione in sospeso',
			panel: {
				title: 'Redazioni',
				itemCount: '{count} redazione in sospeso',
				itemCountPlural: '{count} redazioni in sospeso',
				clearAll: 'Cancella tutto',
				redactAll: 'Redigi tutto',
			},
		},
		history: {
			undo: 'Annulla',
			redo: 'Ripeti',
		},
		comments: {
			page: 'Pagina {page}',
			commentCount: '{count} commento',
			commentCountPlural: '{count} commenti',
			addComment: 'Aggiungi commento...',
			addReply: 'Aggiungi risposta...',
			showAllAnnotations: 'Mostra tutte le annotazioni',
			closeAllAnnotations: 'Chiudi tutte le annotazioni',
			save: 'Salva',
			cancel: 'Annulla',
			edit: 'Modifica',
			delete: 'Elimina',
			showMore: 'altro',
			showLess: 'meno',
			emptyState: 'Aggiungi annotazioni per poterle commentare.',
		},
		blendMode: {
			normal: 'Normale',
			multiply: 'Moltiplica',
			screen: 'Scolora',
			overlay: 'Sovrapponi',
			darken: 'Scurisci',
			lighten: 'Schiarisci',
			colorDodge: 'Scherma colore',
			colorBurn: 'Brucia colore',
			hardLight: 'Luce intensa',
			softLight: 'Luce soffusa',
			difference: 'Differenza',
			exclusion: 'Esclusione',
			hue: 'Tonalità',
			saturation: 'Saturazione',
			color: 'Colore',
			luminosity: 'Luminosità',
		},
		print: {
			title: 'Impostazioni di stampa',
			loading: 'Preparazione documento...',
			pages: 'Pagine da stampare',
			all: 'Tutte le pagine',
			current: 'Pagina corrente ({currentPage})',
			specify: 'Specifica pagine',
			specifyEG: 'es. 1-3, 5, 8-10',
			total: 'Pagine totali nel documento: {totalPages}',
			annotation: 'Includi annotazioni',
			printing: 'Stampa in corso...',
			print: 'Stampa',
			cancel: 'Annulla',
		},
		protect: {
			title: 'Proteggi documento',
			cancel: 'Annulla',
			apply: 'Applica protezione',
			applying: 'Applicazione...',
			applyFailed: 'Impossibile applicare la protezione. Riprova.',
			removeFailed: 'Impossibile rimuovere la protezione. Riprova.',
			passwordMismatch: 'Le password non corrispondono',
			noProtectionSelected: "Seleziona almeno un'opzione di protezione da applicare.",
			bothPasswordsNote:
				'Gli utenti che aprono con la password del documento avranno permessi limitati. Usa la password del proprietario per sbloccare l’accesso completo.',
			openPassword: {
				title: 'Richiedi password per aprire',
				description: 'Gli utenti devono inserire una password per visualizzare questo documento.',
				label: 'Password documento',
				placeholder: 'Inserisci password',
				confirm: 'Conferma password',
				confirmPlaceholder: 'Conferma password',
			},
			ownerPassword: {
				label: 'Password proprietario',
				placeholder: 'Inserisci password proprietario',
				confirm: 'Conferma password proprietario',
				confirmPlaceholder: 'Conferma password proprietario',
			},
			permissions: {
				title: 'Limita permessi',
				description: 'Limita ciò che gli utenti possono fare con questo documento.',
				allowedActions: 'Azioni consentite',
				print: 'Stampa',
				printHighQuality: 'Stampa in alta qualità',
				copy: 'Copia contenuto',
				accessibility: 'Estrazione per accessibilità',
				modify: 'Modifica contenuto',
				annotations: 'Aggiungi/modifica annotazioni e commenti',
				fillForms: 'Compila moduli e firma',
				assemble: 'Assembla ed estrai pagine',
			},
			encrypted: {
				title: 'Il documento è protetto',
				description:
					'Questo documento è protetto dal proprietario. Inserisci la password del proprietario per modificare le impostazioni di sicurezza.',
				enterOwnerPassword: 'Inserisci la password del proprietario per modificare',
				unlockAndEdit: 'Sblocca e modifica',
			},
			modifyProtection: {
				title: 'Modifica protezione',
				description: 'Scegli come vuoi modificare la protezione del documento.',
				changeOption: 'Cambia password o permessi',
				changeDescription: 'Aggiorna la password del documento o le impostazioni dei permessi.',
				removeOption: 'Rimuovi tutta la protezione',
				removeDescription: 'Rimuovi la protezione con password da questo documento.',
			},
			removeProtection: {
				title: 'Rimuovi protezione',
				warning: 'Sei sicuro di voler rimuovere la protezione?',
				description:
					'Questo rimuoverà tutta la protezione con password dal documento. Chiunque potrà aprirlo e modificarlo.',
				confirm: 'Rimuovi protezione',
			},
		},
		security: {
			protected: {
				title: 'Questo documento è protetto',
				description:
					'Questo file è protetto e alcune funzionalità potrebbero essere disabilitate. Vai su Sicurezza nel menu del documento per visualizzare o sbloccare i permessi.',
				viewPermissions: 'Visualizza permessi',
			},
			viewPermissions: {
				title: 'Permessi documento',
				description:
					'Questo file è limitato dal proprietario e richiede una password per sbloccare determinate azioni.',
				restrictedActions: 'Azioni limitate',
			},
			unlock: {
				label: 'Inserisci la password del proprietario per sbloccare il file',
				placeholder: 'Inserisci password proprietario',
				button: 'Sblocca file',
				invalidPassword: 'Password non valida. Riprova.',
				failed: 'Sblocco non riuscito. Riprova.',
				success: 'Permessi del proprietario sbloccati! Ora hai accesso completo.',
			},
		},
		common: {
			close: 'Chiudi',
			back: 'Indietro',
			cancel: 'Annulla',
		},
		link: {
			title: 'Inserisci link',
			url: 'URL',
			page: 'Pagina',
			enterUrl: 'Inserisci URL',
			enterPage: 'Inserisci numero di pagina',
			pageRange: 'Da pagina 1 a {totalPages}',
			link: 'Link',
		},
		stamp: {
			title: 'Timbri',
			allStamps: 'Tutti i timbri',
			export: 'Esporta timbri',
			emptyState: 'Nessun timbro trovato nella libreria selezionata.',
			createFromSelected: 'Crea timbro',
			createFromGroup: 'Crea timbro dal gruppo',
			library: {
				custom: 'Timbri personalizzati',
			},
		},
		signature: {
			title: 'Firme',
			createNew: 'Crea nuova firma',
			createNewWithInitials: 'Crea firma e iniziali',
			placeSignature: 'Firma',
			placeInitials: 'Iniziali',
			remove: 'Rimuovi firma',
			emptyState: 'Nessuna firma. Creane una per iniziare.',
			create: {
				title: 'Crea firma',
				draw: 'Disegna',
				type: 'Digita',
				upload: 'Carica',
				signatureLabel: 'Firma',
				initialsLabel: 'Iniziali',
				clear: 'Cancella',
				typePlaceholder: 'es. Mario Rossi',
				initialsPlaceholder: 'es. MR',
				uploadPlaceholder: "Clicca o trascina un'immagine qui",
				font: 'Carattere',
				color: 'Colore',
				cancel: 'Annulla',
				save: 'Salva',
			},
		},
	},
};
